import { getPersistedViewerSession } from './viewerSession';

const LEADER_SESSION_KEY = 'leaderSession';

/** Longer than any game, so an old link doesn't quietly go live again. */
const MAX_AGE_MS = 12 * 60 * 60 * 1000;

/**
 * Remembers the game this device is sharing. Phones often reload a page left
 * in the background, and a scorekeeper who forgot the session would stop
 * updating everyone watching with nothing to tell them. localStorage, not
 * sessionStorage: an installed app that gets closed starts a new session.
 */
export function persistLeaderSession(id: string): void {
  try {
    localStorage.setItem(
      LEADER_SESSION_KEY,
      JSON.stringify({ id, startedAt: Date.now() }),
    );
  } catch {
    // Without storage the session lasts as long as the page, as it used to.
  }
}

export function clearPersistedLeaderSession(): void {
  try {
    localStorage.removeItem(LEADER_SESSION_KEY);
  } catch {
    // Nothing was saved, then.
  }
}

/** The session to carry on sharing when the page opens, if there is one. */
export function getPersistedLeaderSession(): string | null {
  try {
    // A watch link, or a tab already watching, shows someone else's game.
    if (
      new URLSearchParams(window.location.search).has('session') ||
      getPersistedViewerSession()
    ) {
      return null;
    }
    const saved = JSON.parse(localStorage.getItem(LEADER_SESSION_KEY) ?? 'null');
    if (typeof saved?.id !== 'string' || typeof saved?.startedAt !== 'number') {
      return null;
    }
    if (Date.now() - saved.startedAt > MAX_AGE_MS) {
      clearPersistedLeaderSession();
      return null;
    }
    return saved.id;
  } catch {
    return null;
  }
}
